import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AttendanceCard  {
    _originalTypeClassName = "zERP.BO.AttendanceCard";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AttendanceCard.translate = translateService;
}
this.Id = null;
this.ValidFrom = null;
this.ValidTo = null;
this.CardStatus = null;
this.Comments = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ValidFrom:any;
ValidTo:any;
CardStatus:any;
Comments:any;
Contract:any;
CardID:any;
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
}
}
static setCardID = ($this, value) => {
var oldValue = $this.CardID;
$this.CardID = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}